import React, { useContext } from 'react'
import { QuizContext } from '../contexts/QuizContext'

import Logo from '../assets/images/logo.png'

const Header = () => {

	const quizContext = useContext(QuizContext)

	const startQuiz = () => {
		quizContext.setCurQuestion(1)
		quizContext.setScore(0)
		quizContext.setQuestions({})
		quizContext.setAnswer('')

		quizContext.getQuestions()
	}

	return (
		<div className="nav">
			<div className="container">
				<div className="flex flex-between flex-alignitemcenter">
					<div className="logoimage"><img src={Logo} alt="Logo" /></div>
					<div>
						<ul className="navs">
							<li>Home</li>
							<li onClick={startQuiz} style={{cursor:"pointer"}}>Start Quiz</li>
						</ul>
					</div>
				</div>
			</div>
		</div>
	)
}

export default Header
